import { vysionTrack } from './vysionService';

const setGlobalVysion = (param: any): void => {
  param.event && vysionTrack(param, param.page);
};

export { setGlobalVysion };
